module.exports = __webpack_public_path__ + "img/right.004e3473.png";